import { Component, inject, Inject } from '@angular/core';
import { IconComponent } from '../../helper/icon/icon.component';
import { MatButtonModule } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialog, MatDialogModule } from '@angular/material/dialog';
import { Account } from '../../service/account.service';
import { DisconnectPatreonComponent } from '../disconnect-patreon/disconnect-patreon.component';
import { RouterLink } from '@angular/router';
import { PowProgressComponent } from '../../helper/pow-progress/pow-progress.component';
import { PowService, PowSolution } from '../../service/pow.service';

@Component({
  selector: 'app-connect-patreon',
  imports: [PowProgressComponent, MatDialogModule, MatButtonModule, RouterLink],
  templateUrl: './connect-patreon.component.html',
  styleUrl: './connect-patreon.component.less'
})
export class ConnectPatreonComponent {

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: { user: Account }
  ) {}

  dialog = inject(MatDialog);
  powService = inject(PowService);

  // Proof of work: the connect button stays disabled until pow is set
  pow: PowSolution | null = null;
  powError = false;

  ngOnInit() {
    if (!this.data.user.connections.patreon) {
      this.preparePow();
    }
  }

  async preparePow() {
    this.pow = null;
    this.powError = false;
    try {
      this.pow = await this.powService.solve('patreon');
    } catch (e) {
      console.error('Failed to solve Patreon challenge:', e);
      this.powError = true;
    }
  }

  connectPatreon() {
    if (!this.pow) {
      if (this.powError) this.preparePow();
      return;
    }
    const clientId = '590gN3Yo_MXYGV5MVsHnHS5qfnFwHGVXZH81OVS8u0wkbl3u2cKa3wITmZIM4AAF';
    const redirectUri = 'https://jar.games/patreon';
    const state = encodeURIComponent(JSON.stringify({
      url: window.location.href,
      pow: this.pow,
    }));

    window.location.href = `https://www.patreon.com/oauth2/authorize?client_id=${clientId}&redirect_uri=${redirectUri}&response_type=code&scope=campaigns%20identity.memberships%20identity%20identity%5Bemail%5D&state=${state}`;
  }

  disconnectPatreon() {
    this.dialog.open(DisconnectPatreonComponent, {
      data: {
        user: this.data.user
      }
    });
  }
}
